import React from 'react'

import { getMarginInRems } from '../../utils/style/separator'

const Separator = ({ weight }) => {
  const style = {
    marginBottom: getMarginInRems(weight || 1) * 12
  }
  return <div style={style} />
}

export default Separator
